import { tagNodeName } from '@/services/forms/tmTiptap/const'
import { findJsonContentTags } from '@/services/forms/tmTiptap/utils/findInnermostTags'

export type ParsedTextOrTag = { type: 'text' | typeof tagNodeName; value: string }

const parseTags = (text: string): ParsedTextOrTag[] => {
  const tagOpenChar = '{'
  const tagCloseChar = '}'

  const content: ParsedTextOrTag[] = []
  let contentItem: ParsedTextOrTag | undefined

  for (const char of text) {
    if (!contentItem) {
      contentItem = {
        type: char === tagOpenChar ? tagNodeName : 'text',
        value: char === tagOpenChar ? '' : char,
      }
    } else if (char === tagOpenChar && contentItem.type === 'text') {
      content.push(contentItem)
      contentItem = {
        type: tagNodeName,
        value: '',
      }
    } else if (char === tagCloseChar && contentItem.type === tagNodeName) {
      content.push(contentItem)
      contentItem = undefined
    } else {
      contentItem.value += char
    }
  }

  if (contentItem?.value) {
    if (contentItem.type === 'tag') {
      content.push({ type: 'text', value: `${tagOpenChar}${contentItem.value}` })
    } else {
      content.push(contentItem)
    }
  }

  return content
}

const parseJsonContentTags = (text: string): ParsedTextOrTag[] => {
  const content: ParsedTextOrTag[] = []
  let lastIndex = 0

  findJsonContentTags(text).forEach((match) => {
    if (match.index > lastIndex) {
      content.push({ type: 'text', value: text.slice(lastIndex, match.index) })
    }
    content.push({ type: tagNodeName, value: match.tag })
    lastIndex = match.index + match.text.length
  })

  if (lastIndex < text.length) {
    content.push({ type: 'text', value: text.slice(lastIndex) })
  }

  return content
}

export const parseToJsonTextAndTags = (text: string, isJsonContent = false): ParsedTextOrTag[] => {
  if (isJsonContent) {
    return parseJsonContentTags(text)
  }
  return parseTags(text)
}
